export enum Routes {
  AppHome = '*',
}
